import { EventEmitter, Output } from "@angular/core";
import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import "./navCount.component.scss";

@Component({
    selector: "nav-count",
    template: `<span [ngClass]="{'updated' : updated}"><span [countTo]="count"></span><span class="suffix" *ngIf=suffix>{{suffix}}</span></span>`
})
export class NavCountComponent implements OnChanges {
    // Bindings

    @Input() count: number;
    @Input() suffix: string;

    @Output() onFinishedAnimation = new EventEmitter();

    // Internal

    updated = false;

    constructor() { }

    ngOnChanges(changes: SimpleChanges) {
        this.truncateLargeCount();

        if (changes["count"].firstChange) {
            return;
        }

        this.updated = true;

        setTimeout(() => { this.updated = false; }, 5_000);

        setTimeout(() => { this.onFinishedAnimation.emit(); }, 300);
    }

    //--

    private truncateLargeCount(): void {
        if (!this.count) {
            return;
        }

        if (this.count > 9999) {
            this.count = Math.round(this.count / 1000);

            if (this.suffix?.indexOf("k ") == 0) {
                return;
            }

            this.suffix = "k " + (this.suffix || "");
        }
    }
}
